import {Injectable, OnDestroy} from '@angular/core';
import {auth} from 'firebase/app';
import {AngularFireAuth} from '@angular/fire/auth';
import {Observable, Subscription} from 'rxjs';
import * as firebase from "firebase";

@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnDestroy {

  private authUser: firebase.User;
  private authUserSub = new Subscription();

  constructor(
    private angularFireAuth: AngularFireAuth
  ) {
    this.trackAuthUser();
  }

  private trackAuthUser() {
    this.authUserSub.unsubscribe();
    this.authUserSub = this.angularFireAuth.user.subscribe(authUser => {
      console.log('trackAuthUser', authUser);
      this.authUser = authUser;
    });
  }

  registerUser(email: string, password: string) {
    return this.angularFireAuth.auth.createUserWithEmailAndPassword(email, password);
  }

  signIn(email: string, password: string) {
    return this.angularFireAuth.auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL).then(() => {
      return this.angularFireAuth.auth.signInWithEmailAndPassword(email, password);
    });
  }

  signInWithGoogle() {
    const provider = new auth.GoogleAuthProvider();
    return this.angularFireAuth.auth.signInWithRedirect(provider);
  }

  getProviderId(): string {
    return this.authUser.providerData[0].providerId;
  }

  signOut() {
    return this.angularFireAuth.auth.signOut();
  }

  isSignedIn(): boolean {
    return this.authUser ? true : false;
  }

  getAuthUser(): Observable<firebase.User> {
    return this.angularFireAuth.user;
  }

  getUserEmail(): string {
    return this.authUser && this.authUser.email;
  }

  sendEmailToResetPassword(email: string) {
    return this.angularFireAuth.auth.sendPasswordResetEmail(email);
  }

  ngOnDestroy() {
    this.authUserSub.unsubscribe();
  }

}
